var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCallsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 1010",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 202",
    d: "M0 0h48v48H0z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17279"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17278"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31524",
    d: "M20.852 34.852v-8.535L12.171 13.41A1 1 0 0113 11.852h22a1 1 0 01.828 1.558L27.14 26.317v5.3a1 1 0 01-.4.8l-4.286 3.235a1 1 0 01-1.602-.8zm-5.973-21l7.805 11.6a.988.988 0 01.171.558v6.842l2.292-1.729v-5.11a.988.988 0 01.171-.558l7.8-11.6H14.879z",
    fill: "#fff"
  })))));
}

export default SvgCallsIcon;